(() => {
  const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('fr');
  const parse = (root, selector) => {
    const node = root.querySelector(selector);
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); }
    catch (error) { console.error('The social-etiquette study list could not be loaded.', error); return []; }
  };
  const track = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`french_bites:${name}`, { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: `french_bites_${name}`, ...detail });
  };
  const initialize = (root) => {
    const categories = parse(root, '[data-fgc-categories]');
    const rows = [...parse(root, '[data-fgc-free]'), ...parse(root, '[data-fgc-member]')];
    const member = root.dataset.member === 'true';
    const target = root.querySelector('[data-fgc-sections]');
    const search = root.querySelector('[data-fgc-search]');
    const count = root.querySelector('[data-fgc-count]');
    const empty = root.querySelector('[data-fgc-empty]');
    const live = root.querySelector('[data-fgc-live]');
    if (!target || !search || !count || !empty) return;
    let currentAudio = null;
    let currentButton = null;
    let timer = null;
    const stopAudio = () => {
      if (currentAudio) { currentAudio.pause(); currentAudio.currentTime = 0; }
      if (currentButton) { currentButton.setAttribute('aria-busy', 'false'); currentButton.removeAttribute('aria-pressed'); }
      currentAudio = null;
      currentButton = null;
    };
    const makeAudio = (item) => {
      const button = document.createElement('button');
      button.className = 'fba__audio button button--secondary';
      button.type = 'button';
      button.setAttribute('aria-busy', 'false');
      button.setAttribute('aria-label', `Listen to the complete French entry: ${item[0]}`);
      button.title = `Listen to ${item[0]}`;
      button.disabled = !/^https:\/\//i.test(item[2] || '');
      const icon = document.createElement('span');
      icon.className = 'fba__audio-symbol';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '▶';
      button.append(icon);
      if (!button.disabled) button.addEventListener('click', async () => {
        stopAudio();
        currentButton = button;
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-pressed', 'true');
        currentAudio = new Audio(item[2]);
        currentAudio.preload = 'none';
        currentAudio.addEventListener('playing', () => {
          button.setAttribute('aria-busy', 'false');
          if (live) live.textContent = `Playing ${item[0]}`;
          track('social_etiquette_pronunciation_played', { entry: item[0], member });
        }, { once: true });
        currentAudio.addEventListener('ended', stopAudio, { once: true });
        currentAudio.addEventListener('error', () => {
          stopAudio();
          if (live) live.textContent = `Pronunciation for ${item[0]} is unavailable.`;
        }, { once: true });
        try { await currentAudio.play(); }
        catch (_error) { stopAudio(); if (live) live.textContent = `Pronunciation for ${item[0]} could not play.`; }
      });
      return button;
    };
    const makeRow = (item) => {
      const row = document.createElement('li');
      row.className = 'fba__row fvc__row';
      const position = document.createElement('span');
      position.className = 'fba__position';
      position.textContent = String(item[3]).padStart(4, '0');
      const french = document.createElement('strong');
      french.className = 'fba__french';
      french.lang = 'fr';
      french.textContent = item[0];
      const translation = document.createElement('span');
      translation.className = 'fba__translation';
      translation.textContent = item[1];
      row.append(position, french, translation, makeAudio(item));
      return row;
    };
    const render = () => {
      stopAudio();
      const query = normalize(search.value.trim());
      const visible = query ? rows.filter((item) => normalize(`${item[0]} ${item[1]} ${item[4]}`).includes(query)) : rows;
      const fragment = document.createDocumentFragment();
      for (const category of categories) {
        const items = visible.filter((item) => item[4] === category[0]);
        const available = rows.filter((item) => item[4] === category[0]).length;
        const total = Number(category[3]);
        if (query && !items.length) continue;
        const section = document.createElement('section');
        section.className = 'fvc__category';
        section.id = `category-${category[0]}`;
        const head = document.createElement('div');
        head.className = 'fvc__category-head';
        const heading = document.createElement('h2');
        heading.textContent = category[1];
        const badge = document.createElement('span');
        badge.className = 'fvc__badge';
        badge.textContent = member ? `${total} entries` : `${available} of ${total} free`;
        head.append(heading, badge);
        const intro = document.createElement('p');
        intro.className = 'fvc__category-intro';
        intro.textContent = category[2];
        section.append(head, intro);
        if (items.length) {
          const list = document.createElement('ol');
          list.className = 'fba__list';
          list.start = items[0][3];
          list.append(...items.map(makeRow));
          section.append(list);
        }
        if (!member && available < total) {
          const locked = document.createElement('p');
          locked.className = 'fvc__locked';
          locked.textContent = `${total - available} more entries in this section are available with French Course membership.`;
          section.append(locked);
        }
        fragment.append(section);
      }
      target.replaceChildren(fragment);
      empty.hidden = visible.length !== 0;
      count.textContent = query ? `${visible.length} matching entries` : `${rows.length} entries available`;
      if (live) live.textContent = count.textContent;
    };
    search.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(render, 150);
    });
    root.querySelector('[data-fgc-membership-cta]')?.addEventListener('click', () => track('membership_cta_clicked', { module: 'social-etiquette' }));
    render();
    track('social_etiquette_page_view', { member, available_entries: rows.length });
  };
  document.querySelectorAll('[data-fgc-root]').forEach(initialize);
})();
